/**
 * Product swatches
 * ------------------------------------------------------------------------------
 * A simple script to handle swatch selections on a product form
 *
 * @namespace productSwatches
 */
import cssClasses from '../helpers/cssClasses';
import {getSiblings, on} from '../helpers/utils';

/**
 * DOM selectors.
 */
const selectors = {
  toggleSelector: '[js-product-swatches="toggle"]',
};

/**
 * Export a new product swatch object.
 */
export default () => {

  /**
   * Node selectors.
   */
  const nodeSelectors = {
    toggleSelector: document.querySelectorAll(selectors.toggleSelector),
  };

  /**
   * Initialise component.
   */
  function init() {
    setToggleEvents();
  }

  /**
   * Set listeners.
   */
  function setToggleEvents() {
    [...nodeSelectors.toggleSelector].forEach((element) => {
      on('click', element, (event) => {
        toggleOption(event.currentTarget);
        changeLabel(event.currentTarget);
      });
    });
  }

  /**
   * Toggle selected option.
   * @param {Node} target - DOM node from clicked event.
   */
  function toggleOption(target) {
    const element = target.parentNode;
    const siblings = getSiblings(element);
    element.classList.add(cssClasses.active);
    removeToggled(siblings);
  }

  /**
   * Remove toggle from non-targeted elements.
   */
  function removeToggled(elements) {
    [...elements].forEach((element) => {
      if (element.classList.contains(cssClasses.active)) {
        element.classList.remove(cssClasses.active);
      }
    });
  }

  /**
   * Change label to selected option
   */
  function changeLabel(target) {
    const selectedValue = target.value;
    const selectedLabelElement = target.closest('ul').querySelector(
      '[js-product-swatches="selected-label"]',
    );
    selectedLabelElement.textContent = selectedValue;
  }

  /**
   * Expose public interface.
   */
  return Object.freeze({
    init,
  });
};
